module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8VvTpl/tc-custom/9783958643840_IMGJPG_FrontCover_0.jpg?1703042459607",
      "alt": "This image is the cover for the book Lourdes The Three Cities Trilogy, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lourdes The Three Cities Trilogy, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this moving depiction of a pilgrimage to Lourdes, the master French realist has created a novel of vivid characters and subtle commentary on suffering and the belief in miracles as the last desperate refuge from pain. Based on his own trip to the fabled grotto, the novel follows a simple five-part structure corresponding to the five-day train trip from Paris to Lourdes and back. (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Émile Zola\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Émile Édouard Charles Antoine Zola; 2 April 1840 – 29 September 1902) was a French novelist, playwright, journalist, the best-known practitioner of the literary school of naturalism, and an important contributor to the development of theatrical naturalism. He was a major figure in the political liberalisation of France and in the exoneration of the falsely accused and convicted army officer Alfred Dreyfus, which is encapsulated in the renowned newspaper headline J'accuse. Zola was nominated for the first and second Nobel Prize in Literature in 1901 and 1902. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0